export default "__VITE_ASSET__UzBVuThA__"